import { useEffect, useState } from "react";
import { Link } from "react-router-dom";

/**
 * Mobile-only sticky CTA for Chinnu's physical purchase flow (Command 04).
 * Mirrors StickyBuyBar.jsx's visual style, but links into the
 * delivery-details → review → Razorpay flow instead of opening a modal
 * directly — the physical checkout needs an address first.
 */
export default function PhysicalStickyBar({ href, price, label, testId, accentColor = "#F57F17" }) {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    const onScroll = () => setVisible(window.scrollY > 520);
    onScroll();
    window.addEventListener("scroll", onScroll, { passive: true });
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  return (
    <div
      data-testid={testId}
      className={`books-sticky-buy-bar fixed bottom-0 inset-x-0 z-40 md:hidden bg-white/95 backdrop-blur border-t border-[#E7DFCF] px-4 pt-3 transition-transform duration-300 ${
        visible ? "translate-y-0" : "translate-y-full"
      }`}
      style={{ paddingBottom: "calc(0.75rem + env(safe-area-inset-bottom))" }}
    >
      <div className="flex items-center justify-between gap-3 max-w-[1240px] mx-auto pb-3">
        <span className="font-serif-d text-[22px] text-[#0D1B2A] leading-none">{price}</span>
        <Link
          to={href}
          data-testid={`${testId}-button`}
          style={{ backgroundColor: accentColor }}
          className="inline-flex items-center justify-center px-6 py-3 text-[12px] font-semibold tracking-wide uppercase text-white rounded-sm"
        >
          {label}
        </Link>
      </div>
    </div>
  );
}
